function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 33 30",
  focusable: "false"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.33 30c-.33 0-.65-.02-.99-.07-7.57-1.1-7.9-7.3-8.2-14.1-.23-5.55-.47-9.8-4.23-11.99A6.17 6.17 0 005.9 3.3a4.88 4.88 0 00-3 2.78A1.5 1.5 0 11.1 4.94 7.84 7.84 0 014.94.46a9.2 9.2 0 017.49.79c5.16 3.03 5.46 8.39 5.71 14.45.32 7.48.86 10.57 5.63 11.26 2.63.37 4.74-2.01 6.49-4.4a1.5 1.5 0 012.42 1.77C31.4 26.08 28.53 30 24.33 30",
  id: "Fill-1-Copy"
}))));